import styled from '@emotion/styled';

import COLORS from '../../../../styles/emotion/colors3';
import FONT from '../../../../styles/emotion/fonts';
import MEDIA_QUERY from '../../../../styles/emotion/mediaQueryV2';
import SPACING from '../../../../styles/emotion/spacing';

export const TermsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px var(--footer-desktop-gutter, 40px);

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    flex-direction: column;
    row-gap: ${SPACING.XS};
    ${MEDIA_QUERY.TABLET} {
      padding-top: 9px;
      padding-bottom: 9px;

    p {
      font-size: ${FONT.FONT_SIZE_SMALLER};
    }
  }

  ${MEDIA_QUERY.MOBILE_XS} {
    padding: 40px 20px;
    align-items: flex-start;
  }
`;

export const Copyright = styled.p`
  font-size: ${FONT.FONT_SIZE_SMALLER};
  margin-bottom: 0;

  ${MEDIA_QUERY.MOBILE_XS} {
    color: var(--text-secondary, ${COLORS.BLACK_075});
    margin-top: 16px;
  }
`;

export const TermsList = styled.ul`
  align-items: center;
  column-gap: 24px;
  display: flex;
  flex-wrap: wrap;
  font-size: ${FONT.FONT_SIZE_SMALLER};
  list-style: none;
  padding: 0;
  row-gap: ${SPACING.XS};

  ${MEDIA_QUERY.MOBILE_XS} {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const AccessibilityImg = styled.img`
  width: 50px;
  height: 50px;
`;
